import {
  Box,
  CustomModalLayout,
  Divider,
  Heading,
  Text,
  TextButton,
} from '@wix/design-system';
import React, { useEffect } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { DataHooks } from '../../../../constants/dataHooks';
import { useTemplatesData } from '../../../../hooks/useTemplatesData';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';
import { useGetStartedWixCliModalBi } from '../../../../hooks/useGetStartedWixCliModalBi';
import css from '../../TemplatePage.scss';
import { PreSteps, PrerequisiteStep, prerequisiteSteps } from './PreSteps';
import { TerminalExample } from './TerminalExample/TerminalExample';

interface GetStartWithCLIModalLayoutProps {
  closeModal: () => void;
}

export const GetStartWithCLIModalLayout = ({
  closeModal,
}: GetStartWithCLIModalLayoutProps) => {
  const { t } = useTranslation();
  const { currentTemplate: template } = useTemplatesData();
  const { reportCloseCliModalClick, reportCliPrerequisiteLinkClick } =
    useTemplatesPageBi();
  const { reportModalLoaded, reportCtaClicked } = useGetStartedWixCliModalBi();
  const learnMoreLink = prerequisiteSteps[PrerequisiteStep.CliLearnMore];

  useEffect(reportModalLoaded, []);

  const onLinkClick = () => {
    reportCliPrerequisiteLinkClick(
      template.id,
      PrerequisiteStep.CliLearnMore,
      learnMoreLink,
    );
    reportCtaClicked('Learn more', learnMoreLink);
  };

  const onCloseClick = (ctaName: string) => {
    reportCloseCliModalClick(template.id);
    reportCtaClicked(ctaName);
    closeModal();
  };

  return (
    <CustomModalLayout
      dataHook={DataHooks.CLIModalLayout}
      width={600}
      showHeaderDivider
      showFooterDivider
      title={t('app.template-page.modal.cli.title')}
      primaryButtonText={t('app.template-page.modal.primary-button')}
      onCloseButtonClick={() => onCloseClick('close')}
      primaryButtonOnClick={() => onCloseClick('Done')}
    >
      <Heading size="small">
        {t('app.template-page.modal.cli.steps-title')}
      </Heading>
      <Text size="small" weight="thin">
        {t('app.template-page.modal.cli.steps-subtitle')}
      </Text>
      <PreSteps />
      <div className={css.modalDivider}>
        <Divider />
      </div>
      <Heading size="small">
        {t('app.template-page.modal.cli.select-and-copy-title')}
      </Heading>

      <Box verticalAlign="middle" gap="2px">
        <Text size="small" weight="thin">
          {t('app.template-page.modal.cli.select-and-copy-subtitle')}
        </Text>
        <TextButton
          as="a"
          size="small"
          weight="thin"
          target="_blank"
          onClick={onLinkClick}
          href={learnMoreLink}
          dataHook={DataHooks.CLIModalLearnMoreLink}
        >
          {t('app.template-page.modal.cli.select-and-copy-learn-more')}
        </TextButton>
      </Box>
      <TerminalExample />
    </CustomModalLayout>
  );
};
